import {Component, OnInit, Inject, Input} from '@angular/core';
import {RoleService} from '../../services/role.service';
import {RiskService} from '../../home/services/risk.service';
import {IdvCustomersService} from '../../home/services/idv-customers.service';
import {AddressCustomersService} from '../../home/services/address-customers.service';
import {PepCheckService} from '../../home/services/pep-check.service';
import {BadgeService} from '../../home/services/badge.service';
import {PartnerWalletService} from '../../partner-wallet.service';
import {OrderService} from '../../order-assistant/services/order.service';
import {OrdersService} from '../../home/services/orders.service';
import {ChargebacksService} from "../../home/services/chargebacks.service";

@Component({
  selector: 'app-compliance-nav',
  templateUrl: './compliance-nav.component.html',
  styleUrls: ['./compliance-nav.component.css']
})
export class ComplianceNavComponent implements OnInit {

  @Input() activeMenuItem = '';

  riskActiveInquiries = 0;
  idvActiveInquiries = 0;
  addressActiveInquiries = 0;
  pepsActiveInquiries = 0;
  partnerWalletPendingInvites = 0;
  pendingChargebacks = 0;
  reordersQueuedCount = 0;


  constructor(
    private roleService: RoleService,
    private riskService: RiskService,
    private idvCustomerService: IdvCustomersService,
    private addressCustomerService: AddressCustomersService,
    private pepCheckService: PepCheckService,
    private badgeService: BadgeService,
    private partnerWalletService: PartnerWalletService,
    private orderService: OrdersService,
    private chargebackService: ChargebacksService,
  ) {

    badgeService.badgeEmitter$.subscribe(item => {

      if( item == 'pep' ) {
this.getActivePepInquiries();
}

    });
  }



  ngOnInit() {

    this.getActiveRiskInquiries();
    this.getActiveIdvInquiries();
    this.getActiveAddressInquiries();
    this.getActivePepInquiries();
    this.getReordersQueuedCount();
    this.getPartnerWalletPendingInvites();
    this.getPendingChargebacks();

  }

  getActiveAddressInquiries() {
    try {
      if (!this.currentUserIsPartner()) {
        this.addressCustomerService.getActiveInquiries().subscribe(result => {
            this.addressActiveInquiries = result;
          },
          error => {});
      }
    } catch (e) {
    }
  }

  getActivePepInquiries() {
    try {
      if (this.currentUserIsAdminOrCompliance()) {
        this.pepCheckService.getActiveInquiries().subscribe(result => {
            this.pepsActiveInquiries = result;
          },
          error => {});
      }
    } catch (e) {
    }
  }

  getReordersQueuedCount() {
    try {
      if (this.currentUserIsAdminOrCompliance()) {
        this.orderService.getReordersQueuedCount().subscribe(result => {
            this.reordersQueuedCount = result;
          },
          error => {});
      }
    } catch (e) {
    }
  }

  getPartnerWalletPendingInvites() {
    try {
      if (this.currentUserIsAdminOrCompliance()) {
        this.partnerWalletService.getPendingInvitesCount().subscribe(result => {
            this.partnerWalletPendingInvites = result;
          },
          error => {});
      }
    } catch (e) {
    }
  }

  getPendingChargebacks() {
    try {
      if (this.currentUserIsAdminOrCompliance()) {
        this.chargebackService.getPendingChargebacksCount().subscribe(result => {
            this.pendingChargebacks = result;
          },
          error => {});
      }
    } catch (e) {
    }
  }


  getActiveRiskInquiries() {
    try {
      if (!this.currentUserIsPartner()) {
        this.riskService.getActiveInquiries().subscribe(result => {
          this.riskActiveInquiries = result;
        },
          error => {});
      }
    } catch (e) {
    }
  }

  getActiveIdvInquiries() {
    try {
      if (!this.currentUserIsPartner()) {
        this.idvCustomerService.getActiveInquiries().subscribe(result => {
          this.idvActiveInquiries = result;
        },
          error => {

          });
      }
    } catch (e) {
    }
  }


  currentUserIsAdmin() {
    return this.roleService.hasRoles('admin');
  }

  currentUserIsCompliance(): boolean {
    return this.roleService.hasRoles('compliance');
  }

  currentUserIsPartner(): boolean {
    return this.roleService.hasRoles(['partner', 'partner_support']);
  }

  currentUserIsAdminOrCompliance() {

    if (this.roleService.hasRoles('admin') || this.roleService.hasRoles('compliance')) {
      return true;
    }
    return false;
  }

  currentUserIsAdminOrManagerOrCompliance() {

    if (this.roleService.hasRoles('admin') || this.roleService.hasRoles('manager') || this.roleService.hasRoles('compliance')) {
      return true;
    }

    return false;

  }

  currentUserIsAdminOrComplianceOrFinanceManagerOrManagerOrIssuerExternal(): boolean {
    return this.roleService.hasRoles(['admin', 'compliance', 'finance_manager', 'manager', 'issuer_external']);
  }

  currentUserIsComplianceManager(): boolean {
    return this.roleService.hasRoles(['compliance_manager']);
  }

  currentUserIsAdminOrFinanceManager(): boolean {
    return this.roleService.hasRoles(['admin', 'finance_manager']);
  }

  getBadgeContent(leNumber: number): string {
    if (leNumber >= 10000) {
      return '++';
    }

    const thresholds = [9000, 8000, 7000, 6000, 5000, 4000, 3000, 2000, 1000];
    const labels = ['9k+', '8k+', '7k+', '6k+', '5k+', '4k+', '3k+', '2k+', '1k+'];

    for (let i = 0; i < thresholds.length; i++) {
      if (leNumber >= thresholds[i]) {
        return labels[i];
      }
    }
    return leNumber.toString();
  }

}
